<template>
  <div class="card">
    <div class="header">
      <div class="bg-image">
        <img :src="require(`./images/bg-${bgImage}.png`)" alt="" />
      </div>
      <div class="title">
        <span class="text">{{ title }}</span>
        <span :class="['num', { normal: parseInt(totalNum) === 0 }]">{{
          totalNum
        }}</span>
      </div>
      <div class="classify-list">
        <div>
          <img
            :src="require(`./images/${imgName}.png`)"
            alt=""
            class="title-img"
          />
        </div>
        <ul class="list">
          <li class="item" v-for="item in titleList" :key="item.text">
            <span class="triangle"></span>
            <span class="text">{{ item.text }}</span>
            <span :class="['num', { normal: item.num === 0 }]">{{
              item.num > 9999999 ? '>1000万' : item.num
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="body">
      <ul class="body-list">
        <li
          :class="['body-ltem', cursor ? 'cursor' : '']"
          v-for="(item, index) in briefList"
          :key="item.id"
          @click="briefItemClick(item)"
          @mouseenter="currentIndex = index"
          @mouseleave="currentIndex = -1"
        >
          <span class="time">{{ item.time }}</span>
          <span class="content"
            >{{
              item.brief.length > 32
                ? item.brief.substring(0, 32) + '...'
                : item.brief
            }}
          </span>
          <span
            class="brief-desc"
            v-show="index === currentIndex && item.brief.length > 32"
            >{{ item.brief }}</span
          >
        </li>
      </ul>
      <div class="more" @click="moreClick">查看更多</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgImage: {
      type: String,
      default: 'circle'
    },
    title: {
      type: String,
      default: ''
    },
    totalNum: {
      type: String,
      default: ''
    },
    imgName: {
      type: String,
      default: 'note'
    },
    titleList: {
      type: Array,
      default() {
        return [];
      }
    },
    briefList: {
      type: Array,
      default() {
        return [];
      }
    },
    cursor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: -1
    };
  },
  methods: {
    briefItemClick(item) {
      this.$emit('briefItemClick', item);
    },
    moreClick() {
      this.$emit('moreClick');
    }
  }
};
</script>

<style lang="stylus" scoped>
.card
  width 290px
  .header
    padding 0 20px
    border-radius 8px 8px 0 0
    position relative
    .bg-image
      position absolute
      left 0
      top 0
      bottom 0
      right 0
      z-index 0
      img
        display block
        width 100%
    .title
      position relative
      border-bottom 1px solid rgba(206, 219, 239, 0.2)
      overflow hidden
      line-height 60px
      font-size 18px
      .text
        float left
        font-weight bold
      .num
        float right
        color #FFB439
        &.normal
          color #fff
    .classify-list
      padding-top 16px
      position relative
      display flex
      padding-bottom 28px
      height 92px
      .title-img
        display block
        margin-right 15px
        width 80px
      .list
        flex 1
        font-size 12px
        .item
          line-height 19px
          .triangle
            display inline-block
            width 0
            height 0
            border-width 4px 6px 4px 6px
            border-style solid
            border-color transparent transparent transparent #CEDBEF
          .num
            float right
            color #FFB439
            &.normal
              color #fff
  .body
    background #fff
    height 366px
    background #fff
    border-radius 8px
    transform translate(0, -26px)
    position relative
    .body-list
      padding 5px 20px 0 20px
      .body-ltem
        color #242424
        font-size 12px
        line-height 20px
        border-bottom 1px solid rgba(217, 228, 244, 0.5)
        padding 9px 0
        height 41px
        position relative
        &.cursor
          cursor pointer
        &:last-child
          border 0
        .time
          margin-right 5px
        .brief-desc
          position absolute
          background #303133
          left -10px
          width 265px
          top -50px
          color #fff
          padding 5px
          border-radius 3px
          &:after
            content ' '
            display inline-block
            width 0
            height 0
            border-width 8px
            border-style solid
            border-color #303133 transparent transparent transparent
            position absolute
            left 50%
            top 100%
            margin-left -8px
    .more
      position absolute
      bottom 0
      left 0
      right 0
      height 55px
      line-height 55px
      color #1D52C0
      text-align center
      font-size 14px
      background #F7F9FE
      border-radius 0 0 8px 8px
      cursor pointer
</style>
